export default __webpack_public_path__ + "static/life_at_05-50ec5fd5dadc92e6086d713820dd3989.jpg";